var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 1.1875H0.9375C0.418945 1.1875 0 1.60645 0 2.125V20.875C0 21.3936 0.418945 21.8125 0.9375 21.8125H25.3125C25.8311 21.8125 26.25 21.3936 26.25 20.875V2.125C26.25 1.60645 25.8311 1.1875 25.3125 1.1875ZM24.1406 4.43359V19.7031H2.10938V4.43359L1.30078 3.80371L2.45215 2.32422L3.70605 3.2998H22.5469L23.8008 2.32422L24.9521 3.80371L24.1406 4.43359ZM22.5469 3.29688L13.125 10.6211L3.70312 3.29688L2.44922 2.32129L1.29785 3.80078L2.10645 4.43066L12.1143 12.2119C12.4021 12.4355 12.7561 12.5569 13.1206 12.5569C13.4851 12.5569 13.8391 12.4355 14.127 12.2119L24.1406 4.43359L24.9492 3.80371L23.7979 2.32422L22.5469 3.29688Z",
    fill: "#2091F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.55bf571702b185973e4f7f1866d1b6f7.svg";
export { ForwardRef as ReactComponent };